module.exports = __webpack_public_path__ + "static/group-e31c8ea024ca524456c9ddcc24f603e0.png";